import { Block } from '@comp/crRender'
import './style.css'
import ProviderCard from './components/ProviderCard'
import ContactInfo from './components/ContactInfo'
import ProviderDocs from './components/ProviderDocs'

const Details = ({ requestDetails }) => {

    return (
        <Block isRender={!!requestDetails} className="provider-rr-container">
            <div className="provider-rr-grid">
                <ProviderCard requestDetails={requestDetails} />
                <ContactInfo requestDetails={requestDetails} />
            </div>

            <ProviderDocs documents={requestDetails?.files?.filterWhenNot('name', 'logo')} />
        </Block>
    )
}

export default Details
